import { ThemeProvider } from '@mui/material'
import { Fragment, useState } from 'react'
import { useLayoutEffect } from 'react'

const ThemeSelector = ({ countryCapitalize, children }) => {
    const [theme, setTheme] = useState()

    useLayoutEffect(() => {
        if (!theme) {
            const themeName = `${countryCapitalize}FormTheme`
            import(`../Forms/Theme/${themeName}`).then(module => {
                setTheme(module.FormTheme)
            })
        }
    }, [countryCapitalize, theme])

    return <Fragment>{theme ? <ThemeProvider theme={theme}>{children}</ThemeProvider> : null}</Fragment>
}
export default ThemeSelector
